import { render, staticRenderFns } from "./BdMessage.vue?vue&type=template&id=0ea6ba90&"
import script from "./BdMessage.vue?vue&type=script&lang=js&"
export * from "./BdMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports